import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IpService } from 'projects/shop/src/app/+shared/services/user-ip.service';
import { countriesService } from 'projects/shop/src/app/modules/home/services/countries.service';
import { BrowserService } from '../services/browser.service';
import { getCountryCode } from './../utils/helpers';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';

@Injectable()
export class DevAccessInterceptor implements HttpInterceptor {

  constructor(private _injector: Injector, private _countryService: countriesService, private _browser: BrowserService, private _languageService: LanguageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let req = request;
    if (request.url.includes('-dev.')) {
      req = request.clone({
        headers: request.headers.set('X-API-Key', 'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS')
      });
    }

    if (req.url.includes('suggestions')) {
      const ipService = this._injector.get(IpService);
      this._languageService.selectedCountry.subscribe(
        res => {
          console.log('res: ', res);
          if (res.length) {
            req = req.clone({
              headers: req.headers.set('X-User-Country', this.countryCode())
            })
          }
        }
      )
    }
    return next.handle(req);
  }

  countryCode() {
    let userRegion = JSON.parse(this._browser.getLocalStorage()?.getItem('UserRegion')!);
    let countryKey = userRegion.country.includes(' ') ? userRegion.country.replace(' ', '_').toLowerCase() : userRegion.country.toLowerCase()
    return this._countryService?.countryCodes[countryKey]
  }
}